"use client";
import { SwapVert as StartIcon } from "@mui/icons-material";

import { useStore, observer } from "../../../../service/mobx";
import SearchFilterChip from ".";
import SearchMenu from "../../../../component/Menu/menus/Search";
import { menuOptionsSort } from "../../../../component/Menu/menus/Search/Sort";

export default observer(function FilterSort() {
  const { search } = useStore();
  const disabled =
    search.filterType === undefined || search.filterStars !== undefined;
  const param = "sort";

  return (
    <SearchFilterChip
      param={param}
      disabled={disabled}
      StartIcon={StartIcon}
      options={menuOptionsSort}
      Menu={{
        sx: { menuList: { pt: 0 } },
        Component: () => (
          <SearchMenu
            filter="sort"
            param={param}
            items={Object.entries(menuOptionsSort)}
          />
        )
      }}
    />
  );
});
